document.addEventListener("DOMContentLoaded", function () {
 // Initialize Swiper
const swiper = new Swiper(".block__our-work-slider", {
  loop: true,
  navigation: {
    nextEl: ".work-slider-next",
    prevEl: ".work-slider-prev",
  },
  freeMode: false,
  slidesPerView: 1,
  paginationClickable: false, 
  spaceBetween: 10,  
  loopAdditionalSlides: 2,
  initialSlide: 1,
  grabCursor: false, 
  breakpoints: {
    1599: {
      slidesPerView: 1,
      spaceBetween: 60,
    },
    1399: {
      slidesPerView: 1,
      spaceBetween: 40,
    },
    1199: {
      slidesPerView: 1,
      spaceBetween: 40,
    },
    991: {
      slidesPerView: 1,
      spaceBetween: 30,
    },
    750: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    0: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
  },
  on: {
      slideChangeTransitionEnd: function () {
        // Pause all videos first
        document.querySelectorAll('.block__our-work-slide-media video').forEach(video => {
          video.pause();
        });

        // Get the active slide's video
        const activeSlideVideo = this.slides[this.activeIndex].querySelector('video');

        // If a video exists in the active slide, play it
        if (activeSlideVideo) {
          activeSlideVideo.play();
        }
      },
      // You might also want to play the initial video when the slider loads
      init: function() {
        const initialVideo = this.slides[this.activeIndex].querySelector('video');
        if (initialVideo) {
          initialVideo.play();
        }
      }
    },
});

const cursor = document.getElementById('custom-cursor');
const area = document.querySelector('.custom-cursor-area');

 area.addEventListener('pointermove', (e) => {
  cursor.style.left = `${e.clientX}px`;
  cursor.style.top = `${e.clientY}px`;
});


  area.addEventListener('pointerdown', () => {
  cursor.classList.add('grabbing');
});
area.addEventListener('pointerup', () => {
  cursor.classList.remove('grabbing');
});


});
 